import * as React from 'react';
import { Api } from '../../typings/api';
import { ListDisplayType } from '../../containers/DriveItemList/constants';
import { ThumbnailDescriptor } from '../../utils/driveItem';
import ListItem from '../ListItem';
import RoutesUtils from '../../utils/routes';
import { I18n } from 'react-redux-i18n';

interface NavigationListItemProps {
	displayType: ListDisplayType;
	type: Api.DriveItemType;
	navigationPath?: string;
	url?: string;
	image?: string;
	itemLabel: string;
	isEditMode: boolean;
}

class NavigationListItem extends React.Component<NavigationListItemProps> {
	constructor(props: NavigationListItemProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const { type, navigationPath, url } = this.props;
		if (type === Api.DriveItemType.Directory && navigationPath) {
			RoutesUtils.historyPush(navigationPath);
		}
		if (type === Api.DriveItemType.ExternalLink && url) {
			window.open(url, '_blank');
		}
	}

	render() {
		const { displayType, type, image, itemLabel, isEditMode } = this.props;

		let thumbnailDescriptor: ThumbnailDescriptor;
		if (image) {
			thumbnailDescriptor = {
				isImage: true,
				src: image,
			};
		} else {
			thumbnailDescriptor = {
				isImage: false,
				src: type === Api.DriveItemType.Directory ? 'iconset_doc_default' : 'iconset_link',
			};
		}

		return (
			<ListItem
				key={itemLabel}
				onClick={this.handleClick}
				showUnreadBadge={false}
				displayType={displayType}
				itemType={type}
				hasActionButton={false}
				label={I18n.t(itemLabel)}
				isSelectedForContextualMenu={false}
				isDownloading={false}
				isDownloaded={false}
				isDownloadInProgress={false}
				isUpdating={false}
				loaderStep={undefined}
				thumbnailDescriptor={thumbnailDescriptor}
				isUnread={false}
				isEditMode={isEditMode}
			/>
		);
	}
}

export default NavigationListItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavigationListItem/index.tsx